import { gql } from '@apollo/client';

const updateSubCommsV2 = gql`
  mutation updateSubCommsV2($value: Boolean!) {
    updateSubComms(value: $value)
  }
`;

export default updateSubCommsV2;
